// CNESS Six Pillars - single source of truth for the frontend.
// Pillars 7 & 8 (Planet Responsibility, Continuous Conscious Evolution) are inactive.

export const SIX_PILLARS = [
  {
    id: 1,
    name: "Conscious Leadership",
    icon: "Lightbulb",
    color: "#3B82F6",
    bgColor: "#EFF6FF",
    image: "/pillar-icons/conscious-leadership.svg",
    summary:
      "Build responsible decision-making, accountability and leadership practices that align the company with conscious business principles.",
    description:
      "Conscious leadership forms the foundation of a truly purpose-driven organisation. It encompasses integrity in governance, long-term vision over short-term gains, and the empowerment of teams to make ethical decisions. Leaders who embrace consciousness create cultures where values are lived, not just displayed.",
    keyPractices: [
      "Transparent governance and ethical decision-making",
      "Long-term strategic vision aligned with purpose",
      "Empowering teams through trust and delegation",
      "Accountability at every level of leadership",
      "Continuous learning and adaptive leadership",
    ],
  },
  {
    id: 2,
    name: "Human-Centric Culture & Team Cohesion",
    icon: "Users",
    color: "#8B5CF6",
    bgColor: "#F5F3FF",
    image: "/pillar-icons/Pillar 2_ Social Equity, DEI & Fairness.png",
    summary:
      "Create a people-first workplace where teams feel valued, connected, supported and aligned around a shared purpose.",
    description:
      "A human-centric culture places employee wellbeing, inclusion, and collaboration at the heart of organisational design. When teams feel genuinely valued and connected, they bring their best selves to work, driving innovation and sustainable performance.",
    keyPractices: [
      "Inclusive environments that celebrate diversity",
      "Employee wellbeing programs and support systems",
      "Leadership-driven collaboration and teamwork",
      "Open communication and psychological safety",
      "Recognition and growth opportunities for all",
    ],
  },
  {
    id: 3,
    name: "Products & Services",
    icon: "Target",
    color: "#10B981",
    bgColor: "#ECFDF5",
    image: "/pillar-icons/Pillar 4_ Sustainability & Environmental Impact.png",
    summary:
      "Ensure that what the company offers is useful, responsible and designed to create meaningful value.",
    description:
      "Conscious products and services go beyond profit—they create genuine value for users and society. This pillar evaluates how offerings impact lives, whether innovation is responsible, and if sustainability is embedded in design and delivery.",
    keyPractices: [
      "Products designed with user benefit at the core",
      "Responsible innovation and ethical development",
      "Sustainability integrated into product lifecycle",
      "Transparent sourcing and supply chain practices",
      "Continuous improvement based on user feedback",
    ],
  },
  {
    id: 4,
    name: "Customers & Clients",
    icon: "Heart",
    color: "#F59E0B",
    bgColor: "#FFFBEB",
    image: "/pillar-icons/Pillar 3_ Freedom, Expression & Dignity.png",
    summary:
      "Strengthen trust, care, transparency and long-term relationships with the people and organisations the business serves.",
    description:
      "Building trust with customers requires honest communication, genuine care, and a commitment to their success. Conscious businesses prioritise long-term relationships over transactional interactions, creating advocates rather than just customers.",
    keyPractices: [
      "Honest and transparent communication",
      "Customer success as a primary metric",
      "Responsive and empathetic support",
      "Fair pricing and value-based offerings",
      "Building community among customers",
    ],
  },
  {
    id: 5,
    name: "Community & Conscious Social Impact",
    icon: "HandHeart",
    color: "#06B6D4",
    bgColor: "#ECFEFF",
    image: "/pillar-icons/Pillar 7_ Community Impact & Social Good.png",
    summary:
      "Show how the company contributes beyond profit through community connection, positive impact and responsible growth.",
    description:
      "True conscious enterprises extend their impact beyond their walls. This pillar measures genuine community engagement, philanthropic activities, and the broader positive contributions an organisation makes to society and the environment.",
    keyPractices: [
      "Genuine community engagement programs",
      "Philanthropic activities and giving back",
      "Environmental stewardship and sustainability",
      "Local economic support and development",
      "Measurable social impact initiatives",
    ],
  },
  {
    id: 6,
    name: "Brand Vision & Collaboration",
    icon: "Sparkles",
    color: "#EC4899",
    bgColor: "#FDF2F8",
    image: "/pillar-icons/Pillar 5_ Values-Aligned Partnerships.png",
    summary:
      "Clarify the brand's purpose, voice, partnerships and collaborative role in building a more conscious marketplace.",
    description:
      "A clear brand vision articulates why the organisation exists beyond profit. This pillar examines how well the brand's purpose is defined, communicated, and lived through partnerships and collaborative initiatives that amplify positive impact.",
    keyPractices: [
      "Clearly articulated brand purpose and values",
      "Authentic voice and consistent messaging",
      "Strategic partnerships aligned with purpose",
      "Collaborative initiatives for greater impact",
      "Thought leadership in conscious business",
    ],
  },
];

export const ACTIVE_PILLAR_NUMBERS = SIX_PILLARS.map((p) => p.id);
export const NUM_ACTIVE_PILLARS = SIX_PILLARS.length;

export const PILLAR_NAMES = SIX_PILLARS.reduce((acc, p) => {
  acc[p.id] = p.name;
  return acc;
}, {});

export const PILLAR_NAME_LIST = SIX_PILLARS.map((p) => p.name);
export const PILLAR_COLORS = SIX_PILLARS.map((p) => p.color);
